import { Directive, EmbeddedViewRef, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { FeatureFlag } from 'src/app/shared/models/enums/feature-flag';
import { LDFeatureManager } from 'src/app/shared/services/ld-feature-manager';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

/**
 * @deprecated Please do not use this directive. Use *ifLdFeature="${FeatureFlag.FeatureA};enabled:false" instead
 */
@UntilDestroy()
@Directive({
    selector: '[notIfLdFeature]',
    exportAs: 'notIfLdFeature',
    standalone: true
})
export class NotIfLDFeatureDirective implements OnInit, OnDestroy {
    @Input() notIfLdFeature?: FeatureFlag;
    @Input() notIfLdFeatureEnabled = true;

    view!: EmbeddedViewRef<unknown>;
    constructor(
        private readonly _templateRef: TemplateRef<unknown>,
        private readonly _viewContainer: ViewContainerRef,
        private readonly _featureManager: LDFeatureManager
    ) {}

    ngOnInit() {
        if (this.notIfLdFeature !== undefined) {
            this._featureManager
                .isDisabled(this.notIfLdFeature)
                .pipe(untilDestroyed(this))
                .subscribe((result) => {
                    this._viewContainer.clear();
                    if ((result && this.notIfLdFeatureEnabled) || (!result && !this.notIfLdFeatureEnabled)) {
                        this.view = this._viewContainer.createEmbeddedView(this._templateRef);
                    }
                });
        } else {
            this.view = this._viewContainer.createEmbeddedView(this._templateRef);
        }
    }

    ngOnDestroy(): void {
        if (this.view && !this.view.destroyed) {
            this.view.destroy();
        }
    }
}
